exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".post-cont-header[data-v-ba1f8504]{position:sticky;top:0;z-index:10}.post-header[data-v-ba1f8504]{height:68px;z-index:10;padding:16px;background-color:#f5f5f5}.wid80a[data-v-ba1f8504]{width:80%!important}.mr10[data-v-ba1f8504]{margin-right:10px}.plr16[data-v-ba1f8504]{padding:0 16px}.box0[data-v-ba1f8504]{border:1px solid #93c9da;background-color:#fff;margin-top:20px}.wid200[data-v-ba1f8504]{width:200px}.mb10[data-v-ba1f8504]{margin-bottom:10px}.post-sale-step[data-v-ba1f8504]{padding:0 10px 10px 10px}.pt10i[data-v-ba1f8504]{padding-top:10px!important}.padding-10[data-v-ba1f8504]{padding:10px}", ""]);

// exports
